import { defineStyle, defineStyleConfig } from "@chakra-ui/react";
import { focusRing } from "../foundations/focus";

const baseStyle = defineStyle({
  color: "inherit",
  textDecoration: "none",
  _hover: { textDecoration: "none" },
  _focusVisible: focusRing,
});

const variants = {
  inline: defineStyle({
    color: "brand.600",
    textDecoration: "underline",
    textUnderlineOffset: "3px",
  }),
  nav: defineStyle({
    color: "warm.700",
    transitionProperty: "color",
    transitionDuration: "0.2s",
    transitionTimingFunction: "brand",
    _hover: { color: "ink.DEFAULT" },
    "&[aria-current]": { color: "ink.DEFAULT" },
  }),
};

export const Link = defineStyleConfig({ baseStyle, variants });
